import React from 'react'
import { NoMeetingResult } from './View/NoMeetingResult'
import { SegmentedMeetingResultView } from './View/SegmentedMeetingResultView'
import { StructuredSummaryMeetingResultView } from './View/StructuredSummaryMeetingResultView'
import { AiFeature } from '../../../../../../models/AiFeature'
import { AiResult } from '../../../../../../models/AiResult'

export interface MeetingResultViewProps {
  aiFeature: AiFeature
  aiResult: AiResult
  onFormattedResultChange: (basePath: string, path: string, contentType: string, content: string) => void
}

export const DefaultMeetingResultView: React.FC<MeetingResultViewProps> = ({ aiFeature, aiResult, onFormattedResultChange }) => {
  const { result } = aiResult

  if (!result) {
    return <NoMeetingResult />
  }

  const { type } = result

  if (type === 'segmented') {
    return <SegmentedMeetingResultView aiResult={aiResult} aiFeature={aiFeature} onFormattedResultChange={onFormattedResultChange} />
  }

  if (type !== 'structuredSummary') {
    return null
  }

  return <StructuredSummaryMeetingResultView aiResult={aiResult} aiFeature={aiFeature} onFormattedResultChange={onFormattedResultChange} />
}
